import { styled } from '@mui/material';
import { Modal } from 'components/Modal';

const StyledModal = styled(Modal)`
  padding: 0;
  margin: 0 auto;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    max-width: 820px;
  }
  ${({ theme }) => theme.breakpoints.between('md', 'lg')} {
    max-width: 674px;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }

  & .MuiDialog-paper {
    padding: 0;
    overflow-y: hidden;
  }
  & .MuiDialogContent-root {
    padding: 0 4px;
  }
  & .MuiDialogTitle-root {
    margin-bottom: 27px;
  }
`;

export default StyledModal;
